var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.001,
    r: 3.667,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.284 2.947c.777-1.296 2.655-1.296 3.431 0l.44.735a2 2 0 002.202.912l.832-.208c1.465-.368 2.793.96 2.426 2.426l-.209.83a2 2 0 00.912 2.203l.735.44c1.296.777 1.296 2.655 0 3.431l-.735.44a2 2 0 00-.912 2.202l.209.831c.367 1.466-.96 2.794-2.426 2.427l-.832-.209a2 2 0 00-2.201.912l-.44.735c-.777 1.296-2.655 1.296-3.432 0l-.44-.735a2 2 0 00-2.202-.912l-.831.209c-1.466.367-2.794-.961-2.426-2.427l.208-.83a2 2 0 00-.912-2.202l-.735-.44c-1.296-.777-1.296-2.655 0-3.432l.735-.44a2 2 0 00.912-2.202l-.208-.831c-.368-1.466.96-2.794 2.426-2.426l.83.208a2 2 0 002.203-.912l.44-.735z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default SvgGear;